/**
 * 获取指定名称的cookie值
 * @param name cookie名称
 * @returns {string} cookie值，如果不存在或出错则返回空字符串
 */
export function getCookie(name: string): string {
  try {
    // 检查SSR环境
    if (typeof document === "undefined") {
      return "";
    }

    const { cookie } = document;
    if (!name || !cookie.length) {
      return "";
    }

    for (const item of cookie.split(";")) {
      const [key, value] = item.split("=").map((part) => part.trim());
      if (key === name) {
        return decodeURIComponent(value);
      }
    }
    return "";
  } catch (error) {
    console.warn("获取Cookie失败:", error);
    return "";
  }
}
